import { StyleSheet } from 'react-native';
import { DeviceInfo } from 'qunar-react-native';
import { Colors } from '@qnpm/q-theme';

const { scenes: {baseColor} } = Colors;

export default StyleSheet.create({
    dialogWrapper: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, .7)',
        justifyContent: 'center',
        alignItems: 'center'
    },
    dialog: {
        overflow: 'hidden',
        borderRadius: 8,
        width: 271,
        backgroundColor: '#fff'
    },
    dialogHead: {
        paddingTop: 12,
        paddingBottom: 8,
        paddingHorizontal: 16
    },
    dialogHeadText: {
        lineHeight: 24,
        fontSize: 18,
        color: baseColor.text1,
        textAlign: 'center',
        fontWeight: DeviceInfo.isIOS ? '600' : '400'
    },
    dialogContent: {
        paddingHorizontal: 16,
        paddingTop: 10,
        paddingBottom: 16
    },
    dialogContentText: {
        fontSize: 14,
        color: baseColor.text2,
        lineHeight: 22,
        textAlign: 'center'
    },
    dialogFoot: {
        alignItems: 'center',
        justifyContent: 'center',
        height: 44,
        borderTopWidth: StyleSheet.hairlineWidth,
        borderColor: '#eee'
    },
    dialogBtn: {
        color: '#00bcd4',
        fontSize: 16,
        fontWeight: DeviceInfo.isIOS ? '600' : '400'
    }
});
